var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCutTool = function SvgCutTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 4c0 .488-.131.946-.36 1.34L8 7.057l4.486-4.486a1.333 1.333 0 011.885 0l-8.074 8.074a2.667 2.667 0 11-.942-.943L7.057 8 5.356 6.297A2.667 2.667 0 116.667 4zM5.334 4a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0zm9.037 9.428a1.333 1.333 0 01-1.886 0L8.941 9.884l.943-.943 4.487 4.487zm-3.704-6.095H12v1.334h-1.333V7.333zm2.667 0h1.333v1.334h-1.333V7.333zM4 7.333h1.333v1.334H4V7.333zm-2.667 0h1.334v1.334H1.334V7.333zm2.667 6a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cut-tool_svg__clip0_230_3003"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCutTool;